import React, { useMemo } from "react"
import PropTypes from "prop-types"
import ReactApexChart from "react-apexcharts"

import { ACENTO_COMPRAS } from "../static"
import { numero } from "../format"

/**
 * Kilos por día en barras y pedidos por día en línea, sobre dos ejes: son dos
 * magnitudes con escalas muy distintas y compartir eje aplastaría la línea.
 */
const opcionesSemana = etiquetas => ({
  chart: {
    toolbar: { show: false },
    zoom: { enabled: false },
    fontFamily: "inherit",
    stacked: false,
  },
  colors: [ACENTO_COMPRAS, "#1a1f2e"],
  dataLabels: { enabled: false },
  stroke: { width: [0, 2.5], curve: "smooth" },
  plotOptions: { bar: { columnWidth: "45%", borderRadius: 5 } },
  fill: { opacity: [1, 1] },
  grid: {
    borderColor: "#f0f2f5",
    xaxis: { lines: { show: false } },
  },
  legend: { show: false },
  tooltip: {
    theme: "dark",
    shared: true,
    intersect: false,
  },
  xaxis: {
    categories: etiquetas,
    axisBorder: { show: false },
    axisTicks: { show: false },
    labels: { style: { colors: "#b6bcc7", fontSize: "11px" } },
  },
  yaxis: [
    {
      seriesName: "Kg por día",
      labels: {
        formatter: valor => numero(valor),
        style: { colors: "#b6bcc7", fontSize: "10px" },
      },
    },
    {
      seriesName: "Pedidos",
      opposite: true,
      labels: {
        formatter: valor => numero(valor),
        style: { colors: "#b6bcc7", fontSize: "10px" },
      },
    },
  ],
})

const WeekEvolutionChart = ({ semana }) => {
  const opciones = useMemo(
    () => opcionesSemana(semana.map(dia => dia.dia)),
    [semana]
  )

  const series = useMemo(
    () => [
      { name: "Kg por día", type: "column", data: semana.map(dia => dia.kgs) },
      { name: "Pedidos", type: "line", data: semana.map(dia => dia.pedidos) },
    ],
    [semana]
  )

  return (
    <div className="res-panel res-anim">
      <div className="res-panel-head">
        <h2 className="res-panel-title">Evolución de la semana</h2>
        <div className="res-week-legend">
          <div className="res-legend-item">
            <span
              className="res-legend-key is-bar"
              style={{ background: ACENTO_COMPRAS }}
            />
            Kg por día
          </div>
          <div className="res-legend-item">
            <span className="res-legend-key" style={{ background: "#1a1f2e" }} />
            Pedidos
          </div>
        </div>
      </div>

      <div style={{ padding: "12px 16px 4px" }}>
        <ReactApexChart
          series={series}
          options={opciones}
          type="line"
          height={260}
        />
      </div>
    </div>
  )
}

WeekEvolutionChart.propTypes = {
  semana: PropTypes.array.isRequired,
}

export default WeekEvolutionChart
